<template>
    <span>
        <span class="text-success" v-if="item.ativo"
            ><i
                class="fa fa-toggle-on fa-lg icon-button"
                title="Desativar Item"
                @click.stop="confirmaAtivarDesativar()"
            ></i
        ></span>
        <span class="text-secondary" v-if="!item.ativo"
            ><i
                class="fa fa-toggle-off fa-lg icon-button"
                title="Ativar Item"
                @click.stop="confirmaAtivarDesativar()"
            ></i
        ></span>
    </span>
</template>

<script>
import BaseConhecimentoServicos from './BaseConhecimentoServicos'

export default {
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    },

    methods: {
        confirmaAtivarDesativar() {
            let titulo = `${
                this.item.ativo ? 'Desativação' : 'Ativação'
            } de Item`
            let texto = `Confirma a ${
                this.item.ativo ? 'desativação' : 'ativação'
            } do item <b>${this.item.nome}</b>?`
            this.$swal({
                title: titulo,
                html: texto,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.ativarDesativarItem()
                }
            })
        },

        ativarDesativarItem() {
            this.$store.dispatch('addRequest')
            BaseConhecimentoServicos.ativarDesativarItem(this.item.itemId).then(
                response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Item atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarListaItens', response.data)
                        } else {
                            this.$toast.error(
                                'Erro ao atualizar item.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        }
    }
}
</script>
